import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, thirdWidth } from "../../blocks/layout/columnSpans";

/** The Warehouse API's settings: configuration, synchronisation batches and match keys. */
export const warehouseSettingsPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "WarehouseConfiguration",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 12, mobile: 12 },
          // Both cards run the row's height, so they line up beside each other.
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-configuration",
              title: "Configuration",
              fields: [
                {
                  id: "field-write-only-notice",
                  type: "component",
                  name: "writeOnlyNotice",
                  label: "",
                  componentKey: "warehouseWriteOnlyNotice",
                  span: fullWidth,
                },
                {
                  id: "field-InstallationId",
                  type: "text",
                  name: "InstallationId",
                  label: "Installation ID",
                  helpText: "Unique installation identifier used by the Warehouse API.",
                  readOnly: true,
                  span: thirdWidth,
                },
                {
                  id: "field-OrganisationName",
                  type: "text",
                  name: "OrganisationName",
                  label: "Organisation Name",
                  helpText:
                    "Organisation name used when saving Warehouse API configuration.",
                  readOnly: true,
                  span: thirdWidth,
                },
                {
                  id: "field-MatchThreshold",
                  type: "number",
                  name: "MatchThreshold",
                  label: "Match Threshold",
                  helpText: "Minimum score required for a match to be accepted.",
                  required: true,
                  span: thirdWidth,
                },
                {
                  id: "field-AzureConnectionString",
                  type: "text",
                  name: "AzureConnectionString",
                  label: "Azure Connection String",
                  helpText:
                    "Azure connection string is not displayed after save. Make a note of any replacement value before saving.",
                  validatorKey: "warehouseAzureConnectionString",
                  span: { desktop: 8, tablet: 6, mobile: 12 },
                },
                {
                  id: "field-QueueName",
                  type: "text",
                  name: "QueueName",
                  label: "Queue Name",
                  helpText: "Queue name used by Warehouse API processing.",
                  required: true,
                  span: thirdWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 12, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-synchronisation",
              title: "Synchronisation",
              fields: [
                {
                  id: "field-SynchronisationToCRMBatchSize",
                  type: "number",
                  name: "SynchronisationToCRMBatchSize",
                  label: "To CRM Batch Size",
                  helpText:
                    "Maximum number of Warehouse profile changes sent to CRM per batch.",
                  required: true,
                  span: fullWidth,
                },
                {
                  id: "field-SynchronisationFromCRMBatchSize",
                  type: "number",
                  name: "SynchronisationFromCRMBatchSize",
                  label: "From CRM Batch Size",
                  helpText:
                    "Maximum number of CRM changes read back into Warehouse per batch.",
                  required: true,
                  span: fullWidth,
                },
                {
                  id: "field-SynchronisationMergeBatchSize",
                  type: "number",
                  name: "SynchronisationMergeBatchSize",
                  label: "Merge Batch Size",
                  helpText:
                    "Maximum number of contact merge candidates processed per batch.",
                  required: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "row-match-keys",
      columns: [
        {
          id: "column-match-keys",
          span: fullWidth,
          blocks: [
            {
              kind: "section",
              id: "section-match-keys",
              title: "Match Keys",
              headerComponentKey: "warehouseAddMatchKey",
              fields: [
                {
                  id: "field-MatchKeys",
                  type: "component",
                  name: "MatchKeys",
                  label: "",
                  componentKey: "warehouseMatchKeys",
                  validatorKey: "warehouseMatchKeys",
                  showsOwnErrors: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
